import React, { useEffect } from "react";

const Login = () => {
  useEffect(() => {
    const redirectToSSO = () => {
      const redirectUri = encodeURIComponent(process.env.REACT_APP_REDIRECT_URI);
      const ssoRedirect = `https://sso.thomsonreuters.com/as/authorization.oauth2?client_id=${process.env.REACT_APP_CLIENT_ID}&response_type=code&scope=openid%20profile&redirect_uri=${redirectUri}`;
      window.location.href = ssoRedirect;
    };

    redirectToSSO();
  }, []);

  return <div>Redirecting to login...</div>;
};

export default Login;